<template>
<div style="min-height: 80px; line-height:80px"> 版权所有@2021 沈阳市计算机学会</div>
</template>

<script>
export default {
  name: "foot"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footer/foot.vue